import { render, staticRenderFns } from "./BetaToggle.vue?vue&type=template&id=33f21324&scoped=true"
import script from "./BetaToggle.vue?vue&type=script&lang=ts"
export * from "./BetaToggle.vue?vue&type=script&lang=ts"
import style0 from "./BetaToggle.vue?vue&type=style&index=0&id=33f21324&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f21324",
  null
  
)

export default component.exports